<template lang="pug">
v-row
  v-col
    v-btn(
      large block color="success"
      @click="routeTo('SignIn')"
    ).mb-4 Авторизация
    v-btn(
      large block color="primary"
      @click="getTelegramAuth"
    ).mb-4
      v-icon $telegram
      span Вход через телеграм
    v-btn(
      large block text
      @click="routeTo('SignUp')"
    ).mb-4 Зарегистрироваться
</template>
<script>

export default {

  methods: {
    async getTelegramAuth() {
      const redirect = `/courses/${this.$route.params.id}/view`;
      const { data } = await this.$api.auth.getTelegramAuth();
      const { uri } = data.data;
      window.location.href = `${uri}?redirect=${redirect}`;
      this.closeModal();
    },
    routeTo(route) {
      const redirect = `/courses/${this.$route.params.id}/view`;
      this.$router.push({ name: route, query: { redirect } });
      this.closeModal();
    },
    closeModal() {
      this.$modals.close();
    },
  },

};
</script>
